import i18n from '../../utils/i18n';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import {
  showNotificationAction,
  trackEvent,
  ISSUE_ROOT_CAUSES_FETCH_START,
  ISSUE_ROOT_CAUSES_FETCH_API,
  ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_START,
  ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API,
  ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_FULFILLED,
  ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_REJECTED,
  ISSUE_ROOT_CAUSES_CREATE_START,
  ISSUE_ROOT_CAUSES_CREATE_API,
  ISSUE_ROOT_CAUSES_CREATE_API_FULFILLED,
  ISSUE_ROOT_CAUSES_CREATE_API_REJECTED,
  ISSUE_ROOT_CAUSES_UPDATE_TITLE_START,
  ISSUE_ROOT_CAUSES_UPDATE_TITLE_API,
  ISSUE_ROOT_CAUSES_UPDATE_TITLE_API_REJECTED,
  ISSUE_ROOT_CAUSES_UPDATE_STATUS_START,
  ISSUE_ROOT_CAUSES_UPDATE_STATUS_API,
  ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_REJECTED,
  ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_FULFILLED,
  ISSUE_ROOT_CAUSES_DELETE_API,
  ISSUE_ROOT_CAUSES_DELETE_START,
  ISSUE_ROOT_CAUSES_DELETE_API_FULFILLED,
  ISSUE_ROOT_CAUSES_DELETE_API_REJECTED,
  ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API,
  ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_START,
  ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_FULFILLED,
  ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_REJECTED
} from '../actions';
import {
  issueRootCauseCreate,
  issueRootCauseSetStatusChanged,
  issueRootCauseCategoryCreate,
  issueRootCauseCategorySetStatusChanged,
  issueRootCauseCategoryDelete,
  issueRootCauseDelete
} from '../../utils/analytics-helpers';
import {getIssueRootCauseCategoryById} from '../selectors';
import {isStandardRootCauseCategory} from '../../utils/issueRootCauses-helpers';
import {ISSUE_ROOT_CAUSE_API_ERROR_TYPES} from '../../constants/issue-root-causes';

export default issuesV2Api => store => next => action => {
  const state = store.getState();
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ISSUE_ROOT_CAUSES_FETCH_START: {
      store.dispatch({
        type: ISSUE_ROOT_CAUSES_FETCH_API,
        payload: issuesV2Api.getIssueRootCauses()
      });
      break;
    }
    case ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_START: {
      store.dispatch({
        type: ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API,
        meta: {
          title: action.payload.title,
          isActive: action.payload.isActive,
          onSuccess: action.meta.onSuccess
        },
        payload: issuesV2Api.createIssueRootCauseCategory(action.payload)
      });
      break;
    }
    case ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_FULFILLED: {
      action.meta.onSuccess && action.meta.onSuccess();
      store.dispatch(trackEvent(issueRootCauseCategoryCreate(action.meta.isActive, action.meta.title)));
      break;
    }
    case ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_REJECTED: {
      action.meta.onError && action.meta.onError();
      break;
    }
    case ISSUE_ROOT_CAUSES_CREATE_START: {
      store.dispatch({
        type: ISSUE_ROOT_CAUSES_CREATE_API,
        meta: {
          title: action.payload.title,
          parentId: action.payload.parentId,
          isActive: action.payload.isActive,
          clientID: action.payload.clientID
        },
        payload: issuesV2Api.createIssueRootCause(action.payload)
      });
      break;
    }
    case ISSUE_ROOT_CAUSES_CREATE_API_FULFILLED: {
      const parent = getIssueRootCauseCategoryById(state, action.meta.parentId);
      const isParentStandard = parent && isStandardRootCauseCategory(parent);
      store.dispatch(
        trackEvent(issueRootCauseCreate(isParentStandard, action.meta.isActive, action.meta.title, parent.title))
      );
      break;
    }
    case ISSUE_ROOT_CAUSES_CREATE_API_REJECTED: {
      action.meta.onError && action.meta.onError();
      break;
    }
    case ISSUE_ROOT_CAUSES_UPDATE_TITLE_START: {
      store.dispatch({
        type: ISSUE_ROOT_CAUSES_UPDATE_TITLE_API,
        payload: issuesV2Api.updateIssueRootCause(action.payload.id, action.payload.parentId, {
          title: action.payload.title
        })
      });
      break;
    }
    case ISSUE_ROOT_CAUSES_UPDATE_TITLE_API_REJECTED: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message:
            action.meta && action.meta.parentId
              ? i18n.t('issueRootCauses.notifications.updateTitleErrorIssueRootCause')
              : i18n.t('issueRootCauses.notifications.updateTitleErrorIssueRootCauseCategory')
        })
      );
      break;
    }
    case ISSUE_ROOT_CAUSES_UPDATE_STATUS_START: {
      store.dispatch({
        type: ISSUE_ROOT_CAUSES_UPDATE_STATUS_API,
        payload: issuesV2Api.updateIssueRootCause(action.payload.id, action.payload.parentId, {
          isActive: action.payload.isActive
        }),
        meta: {
          id: action.payload.id,
          parentId: action.payload.parentId,
          isActive: action.payload.isActive
        }
      });
      break;
    }
    case ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_FULFILLED: {
      const issueRootCauseCategory = getIssueRootCauseCategoryById(state, action.meta.id);
      const isStandard = issueRootCauseCategory && isStandardRootCauseCategory(issueRootCauseCategory);
      if (action.meta.parentId) {
        const parent = getIssueRootCauseCategoryById(state, action.meta.parentId);
        const isParentStandard = parent && isStandardRootCauseCategory(parent);
        store.dispatch(trackEvent(issueRootCauseSetStatusChanged(isStandard, isParentStandard, action.meta.isActive)));
      } else {
        store.dispatch(trackEvent(issueRootCauseCategorySetStatusChanged(isStandard, action.meta.isActive)));
      }
      break;
    }
    case ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_REJECTED: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message:
            action.meta && action.meta.parentId
              ? i18n.t('issueRootCauses.notifications.updateStatusErrorIssueRootCause')
              : i18n.t('issueRootCauses.notifications.updateStatusErrorIssueRootCauseCategory')
        })
      );
      break;
    }
    case ISSUE_ROOT_CAUSES_DELETE_START:
      store.dispatch({
        type: ISSUE_ROOT_CAUSES_DELETE_API,
        payload: issuesV2Api.deleteIssueRootCause(action.payload.id),
        meta: {
          title: action.payload.title,
          parentId: action.payload.parentId,
          id: action.payload.id,
          ...action.meta
        }
      });
      break;
    case ISSUE_ROOT_CAUSES_DELETE_API_FULFILLED: {
      action.meta.onSuccess && action.meta.onSuccess();
      store.dispatch(trackEvent(issueRootCauseDelete()));
      break;
    }
    case ISSUE_ROOT_CAUSES_DELETE_API_REJECTED: {
      if (action.payload.response.data.type === ISSUE_ROOT_CAUSE_API_ERROR_TYPES.ROOT_CAUSE_USED_CONFLICT) {
        action.meta.onRootCauseInUseError && action.meta.onRootCauseInUseError();
      } else {
        action.meta.onError && action.meta.onError();
      }
      break;
    }
    case ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_START:
      store.dispatch({
        type: ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API,
        payload: issuesV2Api.deleteIssueRootCauseCategory(action.payload.id),
        meta: {title: action.payload.title, id: action.payload.id, ...action.meta}
      });
      break;
    case ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_FULFILLED: {
      action.meta.onSuccess && action.meta.onSuccess();
      store.dispatch(trackEvent(issueRootCauseCategoryDelete()));
      break;
    }
    case ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_REJECTED: {
      if (action.payload.response.data.type === ISSUE_ROOT_CAUSE_API_ERROR_TYPES.ROOT_CAUSE_USED_CONFLICT) {
        action.meta.onRootCauseCategoryInUseError && action.meta.onRootCauseCategoryInUseError();
      } else {
        action.meta.onError && action.meta.onError();
      }
      break;
    }
  }

  return next(action);
};
